(function () {

  'use strict';

  angular.module('eclipseApp.bts')

    .controller('btsOffersCtrl', ['$rootScope', '$scope', 'uteModal', 'samKeyService', 'uteEndpoint', '$http', 'uteLocale', 'commonService', function ($rootScope, $scope, uteModal, samKeyService, uteEndpoint, $http, uteLocale, commonService) {

      $scope.packageMode = 'browsing';

      $scope.isBtsofferEligible =  true;

      /**
       * if customer has internet - Active / Suspended / Tentative - Not Eligible for internet offers
       * @returns {boolean}
       */
      $scope.isCustomerEligibleForPromotion = function () {
        if (($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent())) {
          if (commonService.customerHasInternetService && commonService.internetAccountStatus !== 'CANCELLED') {
            $scope.isBtsofferEligible =  false;
          }
          var internetAcct = _.filter($rootScope.userInfo.accounts, function (account) {
            return (account.serviceName === 'Internet/TV');
          });
          if (internetAcct && (internetAcct || []).length > 0 && internetAcct[0].status == 'TENTATIVE') {
            $scope.isBtsofferEligible = false;
          }
        }
      };

      $scope.isCustomerEligibleForPromotion();

      /**
       * @description by default the selected tier should be the first one in the sorted list
       * @type {number}
       */
      $scope.selectedTier = 1;

      /**
       * @description the length of the data coming from SS
       * @type {number}
       */
      $scope.totalTiers = 0;

      /**
       * @description click function to determine what tier has been selected
       * @activeTier
       */
      $scope.isSelectedTier = function (activeTier) {
        $scope.selectedTier = activeTier + 1;
      };

      $scope.offerChanged = function (tier, offer) {
        if ($.restive.isPhone()) {
          $('#package-detail').appendTo($('.package-wrapper').eq(tier - 1));
        }
        $scope.selectedSku = offer.offerId;
      };

      $scope.showAvailabilityModal = function () {
        var tier = (samKeyService.tier && samKeyService.tier.tierId) || null;
        samKeyService.showAvailabilityModal('internet', tier); //service, tier, state(targetState)
      };


    }]);


})();
